/**
 * List of available Markup for Button
 */
var ButtonMarkup;
(function (ButtonMarkup) {
    ButtonMarkup["BUTTON"] = "button";
    ButtonMarkup["INPUT"] = "input";
    ButtonMarkup["A"] = "a";
})(ButtonMarkup || (ButtonMarkup = {}));
/**
 * List of available type of Button
 */
var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["RESET"] = "reset";
    ButtonType["SUBMIT"] = "submit";
})(ButtonType || (ButtonType = {}));
/**
 * Button Variant
 */
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["CONVERSION"] = "CONVERSION";
    ButtonVariant["PRIMARY"] = "PRIMARY";
    ButtonVariant["SECONDARY"] = "SECONDARY";
    ButtonVariant["GHOST"] = "GHOST";
})(ButtonVariant || (ButtonVariant = {}));
export { ButtonMarkup, ButtonType };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uRW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvYnV0dG9uL0J1dHRvbkVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxJQUFLLFlBSUo7QUFKRCxXQUFLLFlBQVk7SUFDZixpQ0FBaUIsQ0FBQTtJQUNqQiwrQkFBZSxDQUFBO0lBQ2YsdUJBQU8sQ0FBQTtBQUNULENBQUMsRUFKSSxZQUFZLEtBQVosWUFBWSxRQUloQjtBQUVEOztHQUVHO0FBQ0gsSUFBSyxVQUlKO0FBSkQsV0FBSyxVQUFVO0lBQ2IsK0JBQWlCLENBQUE7SUFDakIsNkJBQWUsQ0FBQTtJQUNmLCtCQUFpQixDQUFBO0FBQ25CLENBQUMsRUFKSSxVQUFVLEtBQVYsVUFBVSxRQUlkO0FBRUQ7O0dBRUc7QUFFSCxNQUFNLENBQU4sSUFBWSxhQUtYO0FBTEQsV0FBWSxhQUFhO0lBQ3ZCLDBDQUF5QixDQUFBO0lBQ3pCLG9DQUFtQixDQUFBO0lBQ25CLHdDQUF1QixDQUFBO0lBQ3ZCLGdDQUFlLENBQUE7QUFDakIsQ0FBQyxFQUxXLGFBQWEsS0FBYixhQUFhLFFBS3hCO0FBV0QsT0FBTyxFQUFFLFlBQVksRUFBRSxVQUFVLEVBQUUsQ0FBQSJ9